export default __webpack_public_path__ + "static/media/T21.51a7913d.png";